import { Config, Ropsten } from "@usedapp/core"

const rpc_url = process.env["REACT_APP_RPC_URL"] || ""

export const config: Config = {
  readOnlyChainId: Ropsten.chainId,
  readOnlyUrls: {
    [Ropsten.chainId]: rpc_url
  }
}